// extracted by mini-css-extract-plugin
export default {"imgdiv":"_6cb50ac7d8 f23033b921","img":"cc8de38b6e d9e7f6e115"};